/* Stallion Keys main-search shortcuts (2026-10-21, Steve's pick "fixes + year shortcut" + SKU + part numbers).
   Runs when a search is submitted (header box) and when a results page opens with ?q= (/search or Searchanise's
   /pages/search-results-page), so it works whichever app handled the Enter key.
   1. Exact SKU (any case, dashes/spaces optional)  -> that listing, opened on that grade (?variant=).
   2. Part number / FCC / IC typed without its dashes, with spaces, or with "pn"/"oem"/"#" in front
      (95440d3510, "8990h 33640", "pn 95440d3510", tq8fob4f27) -> the results for the way the store writes it
      (95440-D3510): both search apps only find these numbers spelled exactly. Also the reverse: 68416785-AA ->
      68416785AA. Numbers the store already writes without separators somewhere (TR47, HY20) are left alone.
   3. Year + car ("2015 camry key", "2017 dodge ram 1500", "chevy silverado 2020 fob") -> the vehicle search results
      /pages/product-result?make&model&year (same data as the Make/Model/Year bar).
   4. Part number with extra words ("95440d3510 key") -> the part number's results.
   5. While typing, the dropdowns (Searchanise's, and the theme's own one) are asked for the store's spelling of
      such a part number (rules 2 and 4), so "95440gi120" shows the 95440-GI120 keys instead of "nothing found".
   6. While typing a year + car ("2025 toyota sienna"), Searchanise's dropdown is asked without the year (titles say
      "2021-2026", never "2025", so it found nothing and fell back to "2025 toyota"), limited to the products that fit
      that year (Searchanise's product_id filter, ids from the vehicle search data); its "View all" opens the vehicle
      search page. Same fitment data as the Make/Model/Year bar, so the dropdown and the vehicle page agree.
   Anything else: normal search, untouched. Read-only: never changes the cart, products or settings.
   Data: assets/msearch-index.js (scripts/build_search_index.py) and the vehicle search's assets/vsearch-data.js. */
(function () {
  "use strict";
  if (window.__STALLION_MSEARCH__) return;
  window.__STALLION_MSEARCH__ = true;

  var CFG = document.currentScript ? document.currentScript.dataset : {};
  var RESULTS = ["/search", "/pages/search-results-page"];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var compact = function (s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/&/g, "and").replace(/[^a-z0-9]+/g, ""); };
  // how the store writes a number, ignoring case and spaces around separators ("5074A- FOB4F71" = "5074A-FOB4F71")
  var tidy = function (s) { return String(s || "").trim().replace(/\s*([-.\/])\s*/g, "$1").replace(/-{2,}/g, "-").replace(/\s+/g, " ").toUpperCase(); };

  /* ---------- data: loaded once per page, a failed load stays failed (null) ---------- */
  var loading = {};
  function loadScript(url, key) {
    if (window[key]) return Promise.resolve(window[key]);
    if (loading[key]) return loading[key];
    return (loading[key] = new Promise(function (ok) {
      if (!url) return ok(null);
      var s = document.querySelector('script[src="' + url + '"]');
      if (!s) { s = document.createElement("script"); s.src = url; s.async = true; document.head.appendChild(s); }
      s.addEventListener("load", function () { ok(window[key] || null); });
      s.addEventListener("error", function () { ok(null); });
      setTimeout(function () { ok(window[key] || null); }, 8000);
    }));
  }
  function index() { return loadScript(CFG.idx, "__MSEARCH_IDX__"); }
  function wantIndex(v) { if (/\d/.test(String(v || ""))) return index(); }   // only searches with a digit need it
  function vehicleData() {
    var el = document.querySelector("[data-data-url]");
    return loadScript(CFG.vdata || (el && el.getAttribute("data-data-url")), "__VSEARCH__");
  }
  var CODE_CHARS = /^[a-z0-9][a-z0-9 _.\/-]*$/i;
  function words(q) { return String(q).trim().split(/\s+/).filter(Boolean); }

  /* ---------- 1. exact SKU ---------- */
  // "sku sk-emk-103", "SKU: SK-A-34": the word sku in front. Left in, Searchanise matches the smart keys whose spec
  // table says "Emergency Key SKU: SK-EMK-103" and not the emergency key itself (Steve 2026-10-23).
  function stripSku(q) { return String(q || "").replace(/^\s*sku\s*[:#.\-]?\s*/i, "").trim(); }
  // The store's SKU key for what was typed: {key, alt}. Steve 2026-10-23 is dropping "SK-" from every SKU family except
  // plain SK-### (SK-EMK-103 -> EMK-103, SK-A-34 -> A-34), so both spellings must keep working, before and after:
  // typed without "SK-" while the store still has it ("emk-103" -> SK-EMK-103), and an old label typed after the
  // rename ("SK-EMK-103" -> EMK-103). alt = matched through the other spelling. Never for part numbers.
  // Not a SKU: a letter + one digit typed without a dash ("a4" = the Audi A4, not SKU A-4; "A-4" still is), and a
  // common word + number typed with a space ("chip 46" = an ID46 chip, not SKU CHIP-46; "chip-46" still is).
  var SKU_WORDS = ["chip", "chips", "lock", "locks", "tag", "tags", "kia"];      // "kia 5" is not SKU KIA-5
  var CAR_CODES = " a3 a4 a5 a6 a7 a8 q3 q5 q7 q8 s3 s4 s5 s6 s7 s8 x1 x2 x3 x4 x5 x6 x7 z3 z4 z8 m2 m3 m4 m5 m6 m8 " +
    "h1 h2 h3 i3 i8 g5 g6 g8 k4 k5 r8 ";                                          // letter + digit car models
  function skuKey(ix, q) {
    var c = compact(q), t = String(q).trim().toLowerCase(), w = words(t);
    // 3 characters is enough for an exact SKU hit (TK-1, AT-9); 2 only with the dash (A-9) (the index holds only real SKUs)
    if (!ix || !ix.s || !CODE_CHARS.test(q) || w.length > 4 || c.length < 2 || (c.length < 3 && !/-/.test(t))) return null;
    if (CAR_CODES.indexOf(" " + c + " ") >= 0 && !/-/.test(t)) return null;
    if (w.length > 1 && SKU_WORDS.indexOf(w[0]) >= 0 && !/-/.test(t)) return null;
    if (ix.s[c]) return { key: c, alt: false };
    if ((ix.p && ix.p[c]) || (ix.u && ix.u[c])) return null;
    var other = c.indexOf("sk") === 0 && !/^sk\d/.test(c) ? c.slice(2) : (/^[a-z]/.test(c) && !/^sk/.test(c) ? "sk" + c : null);
    if (other && ix.s[other]) return { key: other, alt: true };
    // "part-30" / "prt 30" -> XH-PRT-30: PRT is short for part, and the Autel parts carry XH- in front (Steve 2026-10-28)
    var prt = /^(part|prt)\d+$/.test(c) ? "xhprt" + c.replace(/^(part|prt)/, "") : null;
    return prt && ix.s[prt] ? { key: prt, alt: true } : null;
  }
  function skuFromIndex(ix, q) {
    var k = skuKey(ix, q), hit = k && ix.s[k.key];
    return hit ? root + "products/" + ix.h[hit[0]] + (hit[1] ? "?variant=" + hit[1] : "") : null;
  }
  // a SKU added after the index was built: ask Shopify, check the variant SKU exactly. Only for SKU-shaped words
  // (store prefix + digit, one word), so ordinary searches never wait for it.
  function skuFromShopify(ix, q) {
    var c = compact(q), sp = (ix && ix.sp) || ["sk", "oem", "mfk", "tk", "at", "blade", "rshell", "tshell"];
    if (words(q).length > 1 || !/\d/.test(c) || !CODE_CHARS.test(q)) return Promise.resolve(null);
    if (!sp.some(function (p) { return c.indexOf(p) === 0 && c.length > p.length; })) return Promise.resolve(null);
    if (ix && ((ix.p && ix.p[c]) || (ix.u && ix.u[c]))) return Promise.resolve(null);
    var ctl = window.AbortController ? new AbortController() : null;
    var opt = ctl ? { signal: ctl.signal } : {};
    if (ctl) setTimeout(function () { ctl.abort(); }, 1500);
    var u = root + "search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=4&resources[options][fields]=variants.sku";
    return fetch(u, opt).then(function (r) { return r.json(); }).then(function (j) {
      var ps = ((((j || {}).resources || {}).results || {}).products || []).slice(0, 4);
      return Promise.all(ps.map(function (p) {
        return fetch(root + "products/" + p.handle + ".js", opt).then(function (r) { return r.json(); }).then(function (pj) {
          var v = (pj.variants || []).filter(function (x) { return x.sku && compact(x.sku) === c; })[0];
          return v ? root + "products/" + p.handle + "?variant=" + v.id : null;
        }).catch(function () { return null; });
      })).then(function (all) { return all.filter(Boolean)[0] || null; });
    }).catch(function () { return null; });
  }

  /* ---------- 2. part number written differently ---------- */
  // the store's results page is /search (stallion-search-results section, same look as the vehicle search)
  function defaultResults() { return root + "search"; }
  function resultsUrl(written) {
    var p = location.pathname.replace(/\/$/, "");
    written = written.replace(/(^|\s)-(?=\S)/g, "$1");     // never send "-word" (the search app reads it as "without word")
    return (RESULTS.indexOf(p) >= 0 ? p : defaultResults()) + "?q=" + encodeURIComponent(written);   // plain ?q= (Searchanise re-encodes extras)
  }
  // strip what people put around a number: "pn 95440d3510", "P/N: ...", "#95440d3510", "(95440d3510)", "oem 89904-06220"
  function cleanCode(q) {
    var s = String(q).trim().replace(/[()?!"'\[\]]/g, " ").replace(/[\u2010-\u2015]/g, "-");
    s = s.replace(/^#\s*/, "").replace(/^(p\s*\/?\s*n|part\s*(no|number|num|#)?|oem|fcc(\s*id)?|ic)\b\s*[:#.]?\s*/i, "");
    return s.replace(/^#\s*/, "").replace(/[:#,;]+$/, "").trim();
  }
  function codeTarget(ix, code, extraWords) {
    if (!ix || !CODE_CHARS.test(code) || words(code).length > 5) return null;
    var c = compact(code);
    if (c.length < 4 || c.length > 24 || !/\d/.test(c)) return null;
    var hit = ix.p && ix.p[c];
    if (hit) {
      var written = hit[0], typed = tidy(code);
      var known = [tidy(written)].concat(((ix.a && ix.a[c]) || []).map(tidy));
      if (!extraWords && known.indexOf(typed) >= 0) return null;      // already typed the way the store writes it
      return resultsUrl(written);
    }
    var und = ix.u && ix.u[c];                                         // 68416785-AA -> 68416785AA
    // but not words that are codes on their own: "gm hu100" is GM + the HU100 keyway, not the GMHU100 tool
    if (und && /\s/.test(code.trim()) && words(code).some(function (w) {
      var k = compact(w); return k !== c && ((ix.u && ix.u[k]) || (ix.p && ix.p[k]) || (ix.s && ix.s[k]));
    })) und = null;
    if (und && (/[-.\/ ]/.test(code.trim()) || extraWords)) return resultsUrl(und);
    return null;
  }
  function pnWhole(ix, q) {
    var code = cleanCode(q);
    return codeTarget(ix, code, tidy(code) !== tidy(q));    // true when "pn", "#", "( )" etc. were around it
  }
  // "95440d3510 key", "95440 d3510 fob", "hyundai 8990h33640": one real part number (6+ characters) among the words
  function pnInWords(ix, q) {
    var w = words(cleanCode(q)), found = {};
    if (w.length < 2 || w.length > 8) return null;
    for (var n = 3; n >= 1; n--) {
      if (n >= w.length) continue;                       // the whole query is pnWhole's job (never redirect to itself)
      for (var i = 0; i + n <= w.length; i++) {
        var chunk = w.slice(i, i + n).join(" "), c = compact(chunk);
        if (c.length < 6 || !/\d/.test(c) || !CODE_CHARS.test(chunk)) continue;
        // p: numbers the search can't find as typed; u only when typed with a separator the store doesn't use
        var t = (ix.p && ix.p[c]) ? ix.p[c][0] : (/[-.\/]/.test(chunk) && ix.u && ix.u[c]) || null;
        if (t) found[tidy(t)] = t;
      }
    }
    var keys = Object.keys(found);
    return keys.length === 1 ? resultsUrl(found[keys[0]]) : null;
  }

  /* ---------- 3. year + car ---------- */
  var MAKE_WORDS = {                    // what people type -> make name in the vehicle data
    chevy: "Chevrolet", chev: "Chevrolet", chevorlet: "Chevrolet", cheverolet: "Chevrolet", chevolet: "Chevrolet",
    vw: "Volkswagen", volkswagon: "Volkswagen", volkswagen: "Volkswagen", benz: "Mercedes-Benz", mercedes: "Mercedes-Benz",
    mercedez: "Mercedes-Benz", merc: "Mercedes-Benz", mb: "Mercedes-Benz", caddy: "Cadillac", cadilac: "Cadillac",
    landrover: "Land Rover", rangerover: "Land Rover", mini: "MINI", hundai: "Hyundai", hyundia: "Hyundai",
    huyndai: "Hyundai", hyandai: "Hyundai", toyta: "Toyota", toyata: "Toyota", nissian: "Nissan", nissa: "Nissan",
    infinity: "Infiniti", infinti: "Infiniti", porche: "Porsche", porshe: "Porsche", lambo: "Lamborghini",
    bimmer: "BMW", beemer: "BMW", mitsubushi: "Mitsubishi", mitsubichi: "Mitsubishi", mazada: "Mazda",
    subaru: "Subaru", suburu: "Subaru", jagur: "Jaguar", jag: "Jaguar", lexis: "Lexus", acrua: "Acura",
    hummer: "Hummer", olds: "Oldsmobile", rolls: "Rolls-Royce", rollsroyce: "Rolls-Royce", alfa: "Alfa Romeo"
  };
  var FILLER = ("key keys fob fobs keyfob keyfobs remote remotes smart smartkey smartkeys prox proximity flip switchblade " +
    "transponder chip chipped blade blades emergency shell shells case cover replacement replace new oem aftermarket " +
    "genuine original car truck suv van for my the a an and of with to button buttons btn btns push start keyless " +
    "entry ignition starter programmable uncut blank blanks cheap best price buy spare extra lost copy duplicate b " +
    "fits compatible").split(" ");
  var CLASS_WORDS = ["1500", "2500", "3500", "hd", "xl", "super", "duty", "heavy", "crew", "cab", "ld"];
  var TRIMS = ("se le xle xse ce l lx ex exl ex-l dx sv sl sr sr5 trd s gt gts limited hybrid touring sport base premium " +
    "platinum titanium xlt lariat lt ltz ls rs ss denali slt sle at4 laredo latitude sahara rubicon overland " +
    "awd 4wd 4x4 fwd 2wd").split(" ");
  var GENERIC = ("super duty series class truck trucks sport coupe sedan wagon van cab cargo pickup hybrid plug cross " +
    "grand city note crew limited classic mpv").split(" ");
  var NEEDS_MAKE = { "Ford|GT": 1, "Chevrolet|SS": 1, "Lincoln|LS": 1, "Mercedes-Benz|SL": 1 };  // also trim names
  // BMW / Mercedes model codes typed instead of the model (Steve 2026-10-26, #12 "328i", "c300"): 328i -> 3 Series,
  // c300 / ml350 / s550 -> C-Class / M-Class / S-Class. "e350" counts only with the make (Ford E-350 van); Infiniti's
  // G35 / M37 (2 digits) never match.
  var BMW_SERIES = { 1: "1 Series", 2: "2 Series", 3: "3 Series", 4: "4 Series", 5: "5 Series", 6: "6 Series", 7: "7 Series", 8: "8 Series" };
  var MB_CLASS = { c: "C-Class", e: "E-Class", s: "S-Class", cl: "CL-Class", clk: "CLK", cls: "CLS", g: "G-Class", gl: "GL-Class",
    glk: "GLK", ml: "M-Class", r: "R-Class", sl: "SL", slk: "SLK" };
  var CODE_EXTRA = ["amg", "4matic", "xdrive", "sdrive", "coupe", "sedan", "convertible", "cabriolet", "wagon", "gran", "touring"];
  function trimCode(w, make) {                                  // -> {make, model, ask} or null
    var m = /^([1-8])\d\d(i|d|e|xi|ci|is|li|hi|ti|si|ix|xd|ic)$/.exec(w);
    if (m && (!make || make === "BMW")) return { make: "BMW", model: BMW_SERIES[m[1]], ask: "bmw " + BMW_SERIES[m[1]].toLowerCase() };
    m = /^(c|e|s|cl|clk|cls|g|gl|glk|ml|r|sl|slk)([1-9]\d{2}|55|63|65)(amg|4matic|cdi|bluetec|d|h)?$/.exec(w);   // never "r000"
    if (m && (make ? make === "Mercedes-Benz" : m[1] !== "e")) return { make: "Mercedes-Benz", model: MB_CLASS[m[1]], ask: "mercedes " + MB_CLASS[m[1]].toLowerCase() };
    return null;
  }
  // the one model code among the words, when nothing else names a car (filler, trims, "amg" etc. may stay around it)
  function codeIn(ws, make) {
    var hits = ws.map(function (w) { return trimCode(w, make); }), n = hits.filter(Boolean).length;
    if (n !== 1) return null;
    var other = ws.filter(function (w, i) { return !hits[i] && !isFiller(w) && TRIMS.indexOf(w) < 0 && CODE_EXTRA.indexOf(w) < 0; });
    return other.length ? null : hits.filter(Boolean)[0];
  }
  var yearRe = /^(19[6-9]\d|20[0-4]\d)$/;
  var isFiller = function (w) { return FILLER.indexOf(w) >= 0; };

  // misspellings shoppers really typed (Shopify search history 2026-10-26: "subaro" 82x, "cadilac" 33x, "lincolin" 29x...):
  // whole words only, makes / models / brands only - codes are never "corrected" (TR43 and TR47 are different parts)
  var TYPO = {"r000": "95430-R0000", "h001": "HO01", "hoo1": "HO01", "h003": "HO03", "hoo3": "HO03", "f038": "FO38", "merse": "mercedes", "rougi": "rogue", "4runer": "4runner", "acord": "accord", "aitel": "autel", "aurel": "autel", "autal": "autel", "bently": "bentley", "branco": "bronco", "bronko": "bronco", "cadila": "cadillac", "cadilac": "cadillac", "cadill": "cadillac", "cherokke": "cherokee", "cherolet": "chevrolet", "chorse": "xhorse", "chrsyler": "chrysler", "compas": "compass", "corola": "corolla", "corvet": "corvette", "crv": "cr-v", "emegrency": "emergency", "fird": "ford", "gensis": "genesis", "highlender": "highlander", "hinda": "honda", "homda": "honda", "horse": "xhorse", "hundai": "hyundai", "hynda": "hyundai", "hyndai": "hyundai", "infinety": "infiniti", "infinity": "infiniti", "infinty": "infiniti", "jeeo": "jeep", "keikset": "kwikset", "keydit": "keydiy", "kwiksat": "kwikset", "lamborgini": "lamborghini", "lincolen": "lincoln", "lincolin": "lincoln", "loshi": "lishi", "maxda": "mazda", "mazarati": "maserati", "mazaraty": "maserati", "mazdy": "mazda", "mercedeas": "mercedes", "merceds": "mercedes", "mersedes": "mercedes", "nessan": "nissan", "nisan": "nissan", "nissha": "nissan", "nonda": "honda", "odisay": "odyssey", "outel": "autel", "pailot": "pilot", "pasifica": "pacifica", "porsch": "porsche", "porshe": "porsche", "programer": "programmer", "renegait": "renegade", "rouge": "rogue", "saltos": "seltos", "siena": "sienna", "subaro": "subaru", "sudi": "audi", "supeer": "super", "superchip": "super chip", "toyots": "toyota", "toyta": "toyota", "trecer": "tracer", "ultima": "altima", "utel": "autel", "xhirse": "xhorse", "xhoese": "xhorse", "xhorce": "xhorse", "xhores": "xhorse", "xhorsew": "xhorse", "xhorsh": "xhorse", "xhose": "xhorse", "xhrse": "xhorse"};
  function fixTypos(q) {
    var ch = false, s = String(q || "").replace(/[A-Za-z0-9]+/g, function (w) { var f = TYPO[w.toLowerCase()]; if (f) { ch = true; return f; } return w; });
    return ch ? s : null;
  }
  function carWords(q) {
    var s = String(fixTypos(q) || q).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/&/g, " and ");
    s = s.replace(/\b((?:19|20)\d\d)\s*-\s*(?:19|20)\d\d\b/g, "$1");   // a typed year range: its first year
    s = s.replace(/\b\d\s*\+\s*\d\b/g, " ")                                   // 3+1
         .replace(/\b\d{1,2}\s*-?\s*(buttons?|btns?|b)\b/g, " ");               // 4 button, 4-button, 4btn, 5b
    return s.replace(/[^a-z0-9\-\/ ]+/g, " ").split(/\s+/).filter(Boolean);
  }
  // the year when exactly one whole word is a year (a 20xx inside a part number does not count).
  // No 4-digit year: a 2-digit word may be one ("sienna 25", "camry '15 key" -> 2025, 2015; 00-next year = 20xx, else
  // 19xx), but only as a candidate: carTarget keeps it only if the other words then name a car sold that year, so
  // "toyota 86" stays the 86, and numbers next to a unit or chip word ("10 pack", "id 46", "46 chip") never count.
  var NOT_YEAR_BEFORE = ["id", "chip", "4d", "4c", "pcf", "type", "no", "number", "x", "ic", "fcc", "pn", "hu", "ilco"];
  var NOT_YEAR_AFTER = ["pack", "pk", "pcs", "pc", "piece", "pieces", "cut", "cuts", "mhz", "khz", "bit", "bits", "chip",
    "chips", "pin", "pins", "mm", "cm", "in", "inch", "percent", "off", "dollars", "usd"];
  function carYears(q) {                       // [{year: "2025", word: "25"}]
    var ws = carWords(q).map(function (w) {                  // "2023-2025 hyundai santa fe": the first year of a typed range
      var m = /^((?:19|20)\d\d)-(?:19|20)\d\d$/.exec(w); return m ? m[1] : w;
    }), four = ws.filter(function (w) { return yearRe.test(w); });
    if (four.length) return four.length === 1 ? [{ year: four[0], word: four[0] }] : [];
    var yy = new Date().getFullYear() % 100, out = [];
    ws.forEach(function (w, i) {
      if (!/^\d{2}$/.test(w) || NOT_YEAR_BEFORE.indexOf(ws[i - 1]) >= 0 || NOT_YEAR_AFTER.indexOf(ws[i + 1]) >= 0) return;
      var y = String(+w <= yy + 1 ? 2000 + +w : 1900 + +w);
      if (yearRe.test(y) && !out.some(function (c) { return c.word === w; })) out.push({ year: y, word: w });
    });
    return out;
  }
  function carYear(q) { var c = carYears(q); return c.length ? c[0].year : null; }   // "may be a year + car"
  function carTarget(q, V) {
    var cands = carYears(q), hits = [];
    for (var k = 0; k < cands.length; k++) {
      var u = carTargetFor(q, V, cands[k].year, cands[k].word);
      if (u) hits.push(u);
    }
    return hits.length === 1 ? hits[0] : null;     // two different readings ("toyota 86 19" has one) -> normal search
  }
  function carTargetFor(q, V, year, yearWord) {
    var raw = carWords(q).filter(function (w) { return w !== yearWord; });
    if (!raw.length) return null;
    var makes = Object.keys(V.tree);

    // make: by name (compact match of 1-2 words) or by a common nickname; removed by position
    var make = null, mStart = -1, mLen = 0;
    for (var n = 2; n >= 1 && !make; n--) {
      for (var i = 0; i + n <= raw.length && !make; i++) {
        var c = compact(raw.slice(i, i + n).join(" "));
        var m = makes.filter(function (k) { return compact(k) === c; })[0] || MAKE_WORDS[c] || null;
        if (m && V.tree[m]) { make = m; mStart = i; mLen = n; }
      }
    }
    var makeWords = make ? raw.slice(mStart, mStart + mLen) : [];
    var restRaw = make ? raw.slice(0, mStart).concat(raw.slice(mStart + mLen)) : raw.slice();
    var nickRR = make === "Land Rover" && compact(makeWords.join(" ")) === "rangerover";

    function names(mk, md) {
      var al = (V.alias || {})[mk + "|" + md], out = [md].concat(md.split("/"));
      if (al) out.push(al);
      var nf = md.toLowerCase().split(/[\s\/()]+/).filter(function (w) { return w && !isFiller(w); }).join(" ");
      if (nf) out.push(nf);                                                     // Town Car -> town, Ram Truck -> ram
      return out.map(compact).filter(function (x) { return x.length >= 1; });
    }
    function parts(mk, md) {                                                    // XV Crosstrek -> crosstrek, 3500 5500 -> 3500
      return md.split(/[\s\/()]+/).map(compact).filter(function (p) {
        return p.length >= 3 && GENERIC.indexOf(p) < 0 && (/\d/.test(p) || p.length >= 4);
      });
    }
    function find(mks, key, how) {
      var out = [], seen = {};
      if (!key) return out;
      mks.forEach(function (mk) {
        Object.keys(V.tree[mk]).forEach(function (md) {
          var list = how === "parts" ? parts(mk, md) : names(mk, md);
          if (list.indexOf(key) >= 0 && V.tree[mk][md][year] && !seen[mk + "|" + md]) {
            if (!make && NEEDS_MAKE[mk + "|" + md]) return;
            seen[mk + "|" + md] = 1; out.push({ make: mk, model: md });
          }
        });
      });
      return out;
    }
    var mks = make ? [make] : makes;
    var noFill = function (ws) { return ws.filter(function (w) { return !isFiller(w); }); };
    var tries = [];
    function rest(ws) { return compact(noFill(ws).join(" ")); }
    var r0 = noFill(restRaw);
    // Dodge Ram 1500 (2011+) lives under make Ram; Dodge "Ram Truck" (2002-2009) under Dodge
    if (make === "Dodge" && r0[0] === "ram" && r0.length > 1) tries.push([["Ram"], rest(r0.slice(1)), "names"]);
    if (nickRR) tries.push([mks, compact("range rover " + r0.join(" ")), "names"], [mks, rest(r0), "names"]);
    tries.push([mks, rest(r0), "names"]);                                                   // exact name
    if (make) tries.push([mks, compact(makeWords.join(" ") + " " + r0.join(" ")), "names"]); // mazda 3 -> Mazda 3
    var noClass = r0.slice();
    while (noClass.length > 1 && CLASS_WORDS.indexOf(noClass[noClass.length - 1]) >= 0) noClass.pop();
    if (noClass.length < r0.length) tries.push([mks, rest(noClass), "names"]);               // silverado 1500 -> Silverado
    if (r0.length === 1) tries.push([mks, rest(r0), "parts"]);                              // crosstrek, carnival, f350
    if (rest(r0) === "golfgti" || rest(r0) === "gtigolf") tries.unshift([["Volkswagen"], "gti", "names"]);  // Golf + GTI are 2 models
    var tc = codeIn(r0, make);                                                              // 2012 328i, 2014 benz c300
    if (tc) tries.push([[tc.make], compact(tc.model), "names"]);
    var noTrim = r0.filter(function (w) { return TRIMS.indexOf(w) < 0; });
    if (noTrim.length && noTrim.length < r0.length) {                                       // camry se, accord sport
      tries.push([mks, rest(noTrim), "names"]);
      if (noTrim.length === 1) tries.push([mks, rest(noTrim), "parts"]);
    }
    for (var t = 0; t < tries.length; t++) {
      var cands = find(tries[t][0], tries[t][1], tries[t][2]);
      if (cands.length === 1) {
        var u = new URL(root + "pages/product-result", location.origin);
        u.searchParams.set("make", cands[0].make); u.searchParams.set("model", cands[0].model); u.searchParams.set("year", year);
        return u.pathname + u.search;
      }
      if (cands.length > 1) return null;                       // ambiguous ("2015 cruiser": FJ or PT) -> normal search
    }
    return null;
  }
  // rule 6: what Searchanise's dropdown is asked for a year + car, and which listings fit. Synchronous: works once
  // the vehicle data is loaded (it starts loading when a year is typed). null = not a year + car.
  function carDropdown(q) {
    var V = window.__VSEARCH__;
    if (!carYear(q) || !V || !V.tree) return null;
    var u = carTarget(q, V);
    if (!u) return null;
    var sp = new URL(u, location.origin).searchParams, year = sp.get("year");
    var ids = ((V.tree[sp.get("make")] || {})[sp.get("model")] || {})[year] || [];
    var fit = {}, pids = [];
    ids.forEach(function (i) { var c = V.cards[i]; if (c) { fit[c[0]] = 1; if (/^\d+$/.test(c[5] || "")) pids.push(c[5]); } });
    var yw = (carYears(q).filter(function (c) { return c.year === year; })[0] || {}).word || year;   // "25" or "2025"
    var ask = words(q).filter(function (w) { return compact(w) !== yw; }).join(" ");
    return ask && ask !== String(q).trim() ? { ask: ask, url: u, fit: fit, pids: pids, label: year + " " + sp.get("make") + " " + sp.get("model") } : null;
  }
  // no year: "328i key" -> results for "bmw 3 series key" (titles never say 328i; Searchanise found nothing or Lexus)
  function codeAsk(q) {
    if (carYears(q).length) return null;
    var raw = carWords(q), make = null;
    var mk = function (w) { return MAKE_WORDS[compact(w)] || (compact(w) === "bmw" ? "BMW" : null); };
    raw.forEach(function (w) { if (mk(w) && !make) make = mk(w); });                // "mercedes benz c300": both make words go
    var ws = raw.filter(function (w) { return !mk(w); }), tc = codeIn(ws, make);
    if (!tc) return null;
    var keep = ws.filter(function (w) { return !trimCode(w, make) && CODE_EXTRA.indexOf(w) < 0 && TRIMS.indexOf(w) < 0; });
    return [tc.ask].concat(keep).join(" ");
  }
  function codeSearch(q) { var a = codeAsk(q); return a ? resultsUrl(a) : null; }
  // coin batteries (Steve 2026-10-26 "battery search not filtering good"): "2032", "cr2032", "cr 2032", "2032 battery",
  // "panasonic cr2025 5 pack" -> "CR2032 3V Lithium Battery". As typed, the keys whose spec table names that battery came first.
  var CELLS = ["1220", "1616", "1620", "1632", "2016", "2025", "2032", "2330", "2430", "2450"];
  var CELL_WORDS = ("battery batteries batt coin cell lithium 3v volt pack pk panasonic philips toshiba energizer duracell " +
    "for key keys fob remote replacement new 5 4 10 100 of").split(" ");
  function batteryAsk(q) {
    var ws = String(q || "").toLowerCase().replace(/[^a-z0-9 ]+/g, " ").replace(/\bcr\s+(?=\d{4}\b)/g, "cr").split(/\s+/).filter(Boolean);
    var size = null, other = 0;
    ws.forEach(function (w) {
      var m = /^(?:cr)?(\d{4})$/.exec(w);
      if (m && CELLS.indexOf(m[1]) >= 0 && !size) size = m[1];
      else if (CELL_WORDS.indexOf(w) < 0) other++;
    });
    if (!size || other || ws.length > 6) return null;
    var s = " " + ws.join(" ") + " ";                            // "2025 key fob" is a car year, not a battery
    if (/ (key|keys|fob|remote|replacement|new) /.test(s) && !/cr\d|batter|coin|cell|lithium|3v/.test(s)) return null;
    return "CR" + size + " 3V Lithium Battery";      // the battery titles' own words: Searchanise then returns only them
  }
  function carTargetAsync(q) {
    if (!carYear(q)) return Promise.resolve(null);
    return vehicleData().then(function (V) { try { return V && V.tree ? carTarget(q, V) : null; } catch (e) { return null; } });
  }

  /* ---------- glue ---------- */
  // local = true while typing: no network lookups (the "fresh SKU" check runs only on Enter)
  function resolve(q, local) {
    q = String(q || "").trim();
    if (!q || q.length > 80) return Promise.resolve(null);
    // the index is only loaded for code-like searches: a digit, a dash, or one word starting like a SKU
    var codeish = /\d/.test(q) || (words(q).length <= 2 && /-/.test(q)) || /^(sk|rsk|oem|mfk)[a-z]{3,}$/i.test(q) ||
      /^\s*(sku\b|r?sk[\s-])/i.test(q);                    // "sku ...", "SK AUT PC": SKUs without a digit
    var ixP = codeish ? index() : Promise.resolve(null);
    var sq = stripSku(q);                                  // "sku sk-emk-103" -> "sk-emk-103"
    var ba = batteryAsk(q);                                // "2032", "cr2032" -> results for "CR2032 battery"
    if (ba) return Promise.resolve(local || tidy(ba) === tidy(q) ? null : resultsUrl(ba));
    return ixP.then(function (ix) {
      var u = skuFromIndex(ix, q) || (sq !== q && skuFromIndex(ix, sq)) || pnWhole(ix || {}, q);
      if (u) return u;
      // the whole query is itself a number the store knows (typed the way it is written): leave it alone
      var whole = ix && compact(cleanCode(q)), known = ix && ((ix.p && ix.p[whole]) || (ix.u && ix.u[whole]));
      return carTargetAsync(q).then(function (car) {
        return car || (ix && !known && pnInWords(ix, q)) || (local ? null : skuFromShopify(ix, sq));
      }).then(function (u) { var t = fixTypos(q); return u || (local ? null : codeSearch(q) || (t ? resultsUrl(t) : null)); });
    }).catch(function () { return null; });
  }
  // never send people to the page they are on (a redirect loop would reload the results page forever)
  function samePage(u) {
    try {
      var t = new URL(u, location.origin), here = new URLSearchParams(location.search);
      return t.pathname.replace(/\/$/, "") === location.pathname.replace(/\/$/, "") &&
             tidy(t.searchParams.get("q") || "") === tidy(here.get("q") || "");
    } catch (e) { return true; }
  }
  // the store's spelling of a part number typed another way, for the dropdowns (rule 5). Same rules as Enter
  // (pnWhole, then pnInWords unless the words are a year + car); null = send what was typed. Synchronous: works only
  // once the index is loaded (it starts loading when the search box gets focus).
  function storeSpelling(q) {
    var ix = window.__MSEARCH_IDX__;
    q = String(q == null ? "" : q).trim();
    if (!ix || !ix.p || !q || q.length > 80 || !/\d/.test(q)) return null;
    var sq = stripSku(q), k = skuKey(ix, q) || (sq !== q && skuKey(ix, sq));
    if (k) return k.alt ? k.key.toUpperCase() : (sq !== q ? sq : null);   // SKUs: found as typed, else the store's
    // spelling ("emk-103" -> SKEMK103 while the store has SK-EMK-103), without a "sku" word in front
    var u = pnWhole(ix, q);
    if (!u) {
      var whole = compact(cleanCode(q));
      if (ix.p[whole] || (ix.u && ix.u[whole])) return null;      // typed the way the store writes it
      if (carYear(q)) {                                            // a year: Enter may open the vehicle search instead
        var V = window.__VSEARCH__;
        try { if (!V || !V.tree || carTarget(q, V)) return null; } catch (e) { return null; }
      }
      u = pnInWords(ix, q);
    }
    if (!u) return null;
    var w = new URL(u, location.origin).searchParams.get("q");
    return w && tidy(w) !== tidy(q) ? w : null;
  }
  window.StallionMainSearch = { resolve: resolve, storeSpelling: storeSpelling, codeAsk: codeAsk, batteryAsk: batteryAsk, fixTypos: fixTypos };   // for testing: StallionMainSearch.resolve("2015 camry key")

  function reveal() { document.documentElement.classList.remove("msearch-resolving"); }

  // a) results page opened with ?q= : jump if it is a SKU, part number or year + car, else just show the page
  var onResults = RESULTS.indexOf(location.pathname.replace(/\/$/, "")) >= 0;
  var params = new URLSearchParams(location.search);
  var plain = Array.from(params.keys()).every(function (k) { return /^(q|type|options\[prefix\]|country|_pos|_sid|_ss)$/.test(k); });
  if (onResults && params.get("q") && params.get("msearch") !== "off" && plain) {   // not on page 2, filters or sorting
    setTimeout(reveal, 2500);                          // never leave the page hidden
    var started = Date.now();
    resolve(params.get("q")).then(function (u) {
      if (u && !samePage(u) && Date.now() - started < 6000) location.replace(u); else reveal();
    }, reveal);
  } else { reveal(); }

  // b) header search submitted: jump straight there, no results page in between (gives up after 1.5 s)
  document.addEventListener("submit", function (e) {
    var f = e.target, inp = f && f.querySelector && f.querySelector('input[name="q"]');
    if (!inp || !/\/search\b|search-results-page/.test(f.getAttribute("action") || "")) return;
    if (f.dataset.msearchGo) return;                   // second pass: let it submit
    e.preventDefault(); e.stopImmediatePropagation();
    var go = function () {
      f.dataset.msearchGo = "1";
      try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } finally { delete f.dataset.msearchGo; }
    };
    var timer = new Promise(function (ok) { setTimeout(function () { ok(null); }, 1500); });
    Promise.race([resolve(inp.value), timer]).then(function (u) { if (u) location.href = u; else go(); }, go);
  }, true);
  window.addEventListener("pageshow", function () {
    Array.prototype.forEach.call(document.querySelectorAll("form[data-msearch-go]"), function (f) { delete f.dataset.msearchGo; });
  });

  /* ---------- c) while typing: a shortcut line at the top of the Searchanise dropdown ----------
     "Shop by vehicle  2015 Toyota Camry  [See all parts]", "Part number  95440-D3510 \u00b7 2 listings  [Show]",
     "SKU  SK-A-11 + item name  [Open]". It sits at the top of the dropdown content and is put back
     each time Searchanise redraws the dropdown. */
  var hint = null, hintSeq = 0, hintTimer = 0, painting = 0, observer = null, titles = {};
  function hintParts(q, u) {
    var t = new URL(u, location.origin), sp = t.searchParams;
    if (/product-result/.test(t.pathname)) {
      return Promise.resolve(["Shop by vehicle", sp.get("year") + " " + sp.get("make") + " " + sp.get("model"), "See all parts"]);
    }
    if (t.pathname.indexOf(root + "products/") === 0) {
      var handle = t.pathname.slice((root + "products/").length);
      var code = stripSku(q).toUpperCase();
      if (!titles[handle]) {
        titles[handle] = fetch(root + "products/" + handle + ".js").then(function (r) { return r.json(); })
          .then(function (p) { return p.title || ""; }).catch(function () { return ""; });
      }
      return titles[handle].then(function (title) {
        return ["SKU", code + (title ? " \u00b7 " + (title.length > 60 ? title.slice(0, 58) + "\u2026" : title) : ""), "Open"];
      });
    }
    var written = sp.get("q") || q;
    return index().then(function (ix) {
      var e = ix && ix.p && ix.p[compact(written)], n = e ? e.length - 1 : 0;
      return ["Part number", written + (n ? " \u00b7 " + n + (n === 1 ? " listing" : " listings") : ""), "Show"];
    });
  }
  function hintFor(v) {
    v = String(v || "").trim();
    if (v.length < 3) return Promise.resolve(null);
    return resolve(v, true).then(function (u) {
      if (!u || samePage(u)) return null;
      return hintParts(v, u).then(function (parts) { return { url: u, parts: parts, key: u + "|" + parts.join("|") }; });
    }).catch(function () { return null; });
  }
  function ensureStyle() {
    if (document.getElementById("msearch-ac-style")) return;
    var s = document.createElement("style");
    s.id = "msearch-ac-style";
    s.textContent = ".snize-ac-results .msearch-ac-hint{display:flex!important;align-items:center;gap:10px;margin:10px 12px 6px;padding:10px 12px;" +
      "border-radius:8px;background:#080819;color:#fff!important;text-decoration:none!important;cursor:pointer;" +
      "font-family:Montserrat,system-ui,sans-serif;font-size:14px;line-height:1.3}" +
      ".msearch-ac-hint:hover,.msearch-ac-hint:focus{background:#1b1b38;outline:none}" +
      ".msearch-ac-hint .ms-lead{font-size:11px;letter-spacing:.06em;text-transform:uppercase;opacity:.75;white-space:nowrap}" +
      ".msearch-ac-hint .ms-main{font-weight:700;flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}" +
      ".msearch-ac-hint .ms-go{background:#D51313;color:#fff;border-radius:6px;padding:5px 10px;font-size:12px;font-weight:700;white-space:nowrap}" +
      "@media (max-width:600px){.msearch-ac-hint{flex-wrap:wrap}.msearch-ac-hint .ms-main{flex-basis:100%;order:2}" +
      ".msearch-ac-hint .ms-go{margin-left:auto}}" +
      ".snize-ac-results li.msearch-nofit{display:none!important}" +
      ".snize-ac-results li.msearch-fitnote{list-style:none;padding:10px 4px;font-family:Montserrat,system-ui,sans-serif;font-size:13px;color:#5d5e6e}";
    document.head.appendChild(s);
  }
  function paintHint() {
    painting = 0;
    try { filterCar(); } catch (e) { /* leave Searchanise's list as it is */ }
    var boxes = document.querySelectorAll(".snize-ac-results");
    for (var i = 0; i < boxes.length; i++) {
      // top of the dropdown content (Searchanise hides its own custom slot when nothing is found)
      var slot = boxes[i].querySelector(".snize-ac-results-content") || boxes[i];
      var el = null;
      for (var c = slot.firstElementChild; c; c = c.nextElementSibling) if (c.classList.contains("msearch-ac-hint")) { el = c; break; }
      if (!hint) { if (el) el.parentNode.removeChild(el); continue; }
      if (el && el.getAttribute("data-key") === hint.key) { if (slot.firstElementChild !== el) slot.insertBefore(el, slot.firstElementChild); continue; }
      if (!el) {
        el = document.createElement("a");
        el.className = "msearch-ac-hint";
        // keep the search box focused so the dropdown does not close before the click lands
        el.addEventListener("mousedown", function (e) { e.preventDefault(); });
        el.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); location.href = this.getAttribute("href"); });
        slot.insertBefore(el, slot.firstChild);
      }
      el.setAttribute("href", hint.url);
      el.setAttribute("data-key", hint.key);
      el.textContent = "";
      ["ms-lead", "ms-main", "ms-go"].forEach(function (cls, k) {
        var span = document.createElement("span");
        span.className = cls;
        span.textContent = hint.parts[k] + (k === 2 ? " \u2192" : "");
        el.appendChild(span);
      });
    }
  }
  function schedulePaint() {
    if (painting) return;
    painting = setTimeout(paintHint, 20);    // a plain timer: animation frames pause in background windows
  }
  /* ---------- d) while typing: the dropdowns get the store's spelling of a part number ----------
     Searchanise and Shopify only find a part number spelled the way the listing writes it ("95440gi120" -> nothing,
     "95440-GI120" -> the 2 keys). Two hooks, nothing else on the page is touched:
     - Searchanise's dropdown: its own "Searchanise.DataRequestBefore" event hands over the request's parameters right
       before it builds the request and looks in its answer cache, so changing params.q changes both; the box keeps
       what was typed. (Plain typed text: spaces, "+" and the like need no decoding.)
     - the theme's own dropdown (<predictive-search>, shown until Searchanise takes over the box): same, before it asks.
     New listings are covered the morning after they are added (Stallion OS rebuilds the index nightly). */
  var hooked = { snize: false, theme: false };
  var early = null;     // a Searchanise request with a digit that went out before the index arrived: {q, answered}
  var batteryNow = null; // coin battery the dropdown was last asked for ("cr2032 battery")
  var carNow = null;    // rule 6: the year + car the dropdown was last asked for {typed, ask, url, fit, label}

  /* rule 7 (Steve 2026-10-23, "tlk" showed Lexus keys whose note says "needs TLK1", not the TLK1 / TLK2 tools): Searchanise
     reorders its dropdown by what the visitor viewed lately. The dropdown now asks for MORE results, puts the products
     whose TITLE has every searched word first (a word may start a code: "tlk" -> "TLK1"), and shows the usual number.
     DataRequestEnd fires before the dropdown is drawn, also for answers from Searchanise's cache, so the original list is
     kept on the answer (__msAll) and every pass starts from it. */
  var MORE = 18, want = {};
  function titleFirst(params, resp) {
    var key = String(params.q || "").trim().toLowerCase(), n = want[key];
    if (!n || !resp || !resp.items) return;
    var all = resp.__msAll || (resp.__msAll = resp.items.slice());
    var ws = key.split(/[^a-z0-9]+/).filter(function (w) { return w.length > 1 && !yearRe.test(w); });
    var hit = function (it) {
      var t = " " + String(it.title || "").toLowerCase().replace(/[^a-z0-9]+/g, " ");
      return ws.length && ws.every(function (w) { return t.indexOf(" " + w) >= 0; });
    };
    var top = all.filter(hit), rest = all.filter(function (it) { return !hit(it); });
    resp.items = top.concat(rest).slice(0, n);
    resp.currentItemCount = resp.items.length;
  }

  /* e) rule 6, after Searchanise draws the dropdown for a year + car: hide the products that don't fit that year,
     say so when none of them do, and make "View all" open the vehicle search page (all parts that fit). */
  function onlyBatteries(params, resp) {
    if (!batteryNow || String(params.q || "").trim().toLowerCase() !== batteryNow || !resp || !resp.items) return;
    var b = resp.items.filter(function (it) { return /battery/i.test(String(it.title || "")); });
    if (b.length) { resp.items = b; resp.currentItemCount = b.length; }
  }
  function filterCar() {
    var inp = document.activeElement && document.activeElement.name === "q" ? document.activeElement : null;
    var on = !!carNow && (!inp || inp.value.trim().toLowerCase() === carNow.typed);
    var boxes = document.querySelectorAll(".snize-ac-results");
    for (var b = 0; b < boxes.length; b++) {
      var items = boxes[b].querySelectorAll("li.snize-product"), shown = 0;
      for (var i = 0; i < items.length; i++) {
        var a = items[i].querySelector("a[href*='/products/']");
        var h = a ? a.getAttribute("href").replace(/^.*\/products\//, "").split(/[?#]/)[0] : "";
        var hide = on && !!h && !carNow.fit[h];
        if (!hide) shown++;
        if (items[i].classList.contains("msearch-nofit") !== hide) items[i].classList.toggle("msearch-nofit", hide);
        var sep = items[i].nextElementSibling;
        if (sep && sep.classList.contains("snize-separator") && sep.classList.contains("msearch-nofit") !== hide) sep.classList.toggle("msearch-nofit", hide);
      }
      // nothing that fits: Searchanise's "Sorry, nothing found" (its did-you-mean words are not for this car) -> our line
      var none = boxes[b].querySelector("li.snize-no-products-found");
      if (none && none.classList.contains("msearch-nofit") !== (on && !shown)) none.classList.toggle("msearch-nofit", on && !shown);
      var anchor = items[0] || none;
      var note = boxes[b].querySelector(".msearch-fitnote"), want = on && !shown && !!anchor;
      if (want && !note && anchor.parentNode) {
        note = document.createElement("li");
        note.className = "msearch-fitnote";
        anchor.parentNode.insertBefore(note, anchor);
      }
      var msg = want ? "No quick matches for a " + carNow.label + ". Tap \u201cSee all parts\u201d above for everything that fits." : "";
      if (want && note.textContent !== msg) note.textContent = msg;       // only on change: our own edits wake the observer
      else if (!want && note) note.parentNode.removeChild(note);
      var va = boxes[b].querySelector(".snize-view-all-link"), sp = va && va.querySelector("span");
      if (va && sp) {
        if (on && va.getAttribute("data-msearch-url") !== carNow.url) {
          if (!va.hasAttribute("data-msearch-text")) va.setAttribute("data-msearch-text", sp.textContent);
          va.setAttribute("data-msearch-url", carNow.url);
          sp.textContent = "All parts for " + carNow.label;
        } else if (!on && va.hasAttribute("data-msearch-url")) {
          va.removeAttribute("data-msearch-url");
          sp.textContent = va.getAttribute("data-msearch-text") || sp.textContent;
        }
      }
    }
  }
  function viewAllGo(e) {
    var va = e.target && e.target.closest && e.target.closest(".snize-view-all-link[data-msearch-url]");
    if (!va || (e.type === "keydown" && e.key !== "Enter" && e.key !== " ")) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.href = va.getAttribute("data-msearch-url");
  }
  document.addEventListener("click", viewAllGo, true);
  document.addEventListener("keydown", viewAllGo, true);
  function hookDropdowns() {
    var $ = window.Searchanise && window.Searchanise.$;
    if (!hooked.snize && $ && $.fn && typeof $.fn.on === "function") {
      hooked.snize = true;
      $(document).on("Searchanise.DataRequestBefore", function (ev, type, params) {
        try {
          if (type !== "autocomplete" || !params || typeof params.q !== "string") return;
          carNow = null; batteryNow = null;
          var ba = batteryAsk(params.q);
          if (ba) {                                // coin battery: ask for the batteries, keep only them (onlyBatteries)
            params.q = ba; batteryNow = ba.toLowerCase();
            if (+params.maxResults > 0 && +params.maxResults < MORE) { want[batteryNow] = +params.maxResults; params.maxResults = MORE; }
            return;
          }
          var q = params.q, needIx = /\d/.test(q) && !window.__MSEARCH_IDX__, needV = !!carYear(q) && !window.__VSEARCH__;
          if (needIx || needV) {                 // asked as typed for now; asked again once the data is here (askAgain)
            early = { q: q.trim().toLowerCase(), answered: false };
            Promise.all([needIx ? wantIndex(q) : null, needV ? vehicleData() : null]).then(askAgain);
            if (needIx) return;
          }
          var w = storeSpelling(q);
          if (w) { params.q = w; return; }
          // rule 7: ask for more, so title matches can be put on top in DataRequestEnd (see titleFirst)
          if (+params.maxResults > 0 && +params.maxResults < MORE) { want[params.q.trim().toLowerCase()] = +params.maxResults; params.maxResults = MORE; }
          var car = carDropdown(q);              // rule 6
          if (car) {
            car.typed = q.trim().toLowerCase(); carNow = car; params.q = car.ask;
            // only the products that fit (Searchanise's own product_id filter; a copy, never its shared settings object)
            if (car.pids.length && car.pids.length <= 300) params.restrictBy = Object.assign({}, params.restrictBy || {}, { product_id: car.pids.join("|") });
          }
          else { var ca = codeAsk(q) || fixTypos(q); if (ca) params.q = ca; }   // "328i" -> "bmw 3 series", "subaro" -> "subaru"
        } catch (e) { /* send it as typed */ }
      });
      $(document).on("Searchanise.DataRequestEnd", function (ev, type, params, resp) {
        try { if (type === "autocomplete") { titleFirst(params, resp); onlyBatteries(params, resp); } } catch (e) { /* leave Searchanise's order */ }
      });
      $(document).on("Searchanise.DataRequestEnd", function (ev, type, params) {
        if (early && type === "autocomplete" && params && String(params.q).trim().toLowerCase() === early.q) {
          early.answered = true;
          askAgain();
        }
      });
    }
    var PS = !hooked.theme && window.customElements && customElements.get("predictive-search");
    if (PS && typeof PS.prototype.getResults === "function") {
      hooked.theme = true;
      var getResults = PS.prototype.getResults;
      PS.prototype.getResults = function (term) {
        var w = null;
        try { w = batteryAsk(term); if (!w) { wantIndex(term); w = storeSpelling(term); } } catch (e) { /* as typed */ }
        return getResults.call(this, w || term);
      };
    }
  }
  // A part number pasted before the index arrived was asked as typed ("nothing found"), and Searchanise never asks
  // again for unchanged text. Once the index is here AND that answer is in, close the dropdown and open it again the
  // way a click does (Searchanise then asks again, now with the store's spelling). Only if the box still holds that text.
  function askAgain() {
    var e = early, el = document.activeElement, S = window.Searchanise;
    if (!e || !e.answered || !window.__MSEARCH_IDX__ || (carYear(e.q) && !window.__VSEARCH__)) return;
    early = null;
    try {
      if (!el || el.tagName !== "INPUT" || el.value.trim().toLowerCase() !== e.q || !(storeSpelling(e.q) || carDropdown(e.q))) return;
      if (S && typeof S.AutocompleteClose === "function" && S.$) { S.AutocompleteClose(); S.$(el).triggerHandler("click"); }
    } catch (err) { /* leave it: the shortcut line above still shows the part number */ }
  }
  if (window.customElements && customElements.whenDefined) customElements.whenDefined("predictive-search").then(hookDropdowns);
  window.addEventListener("load", hookDropdowns);
  document.addEventListener("focusin", function (e) {      // a box that already holds a part number: get the index ready
    var t = e.target;
    if (!t || t.tagName !== "INPUT" || t.name !== "q") return;
    hookDropdowns();
    wantIndex(t.value);
  }, true);

  document.addEventListener("input", function (e) {
    var t = e.target;
    if (!t || t.tagName !== "INPUT" || t.name !== "q") return;
    hookDropdowns();
    wantIndex(t.value);                                   // first digit typed: start loading the index now
    ensureStyle();
    if (!observer && window.MutationObserver) {         // Searchanise redraws the dropdown on every keystroke
      observer = new MutationObserver(function () { if (hint || carNow || document.querySelector(".msearch-ac-hint, .msearch-nofit, .msearch-fitnote, [data-msearch-url]")) schedulePaint(); });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    clearTimeout(hintTimer);
    var v = t.value, my = ++hintSeq;
    hintTimer = setTimeout(function () {
      hintFor(v).then(function (h) { if (my !== hintSeq) return; hint = h; schedulePaint(); });
    }, 180);
  }, true);
  /* ---------- f) Back button keeps the Make / Model / Year boxes (Steve 2026-10-25) ----------
     The vehicle search boxes are autocomplete="off". WebKit (Safari, every iPhone browser) treats such a box as
     sensitive and, when Back restores the page from memory, wipes it in a task it posts AFTER "pageshow"
     (HTMLInputElement::resumeFromDocumentSuspension -> reset). It skips that when the box has a non-empty value
     ATTRIBUTE (needsSuspensionCallback: "non-empty textual default values ... not really sensitive"). So when the
     page is left, each box's text is also written as its value attribute; on return the text is put back as well,
     now and again a moment later, in case another browser wipes it. The search keeps its own picks in memory. */
  var savedBoxes = [];
  window.addEventListener("pagehide", function () {
    savedBoxes = Array.prototype.map.call(document.querySelectorAll("input[data-combo]"), function (el) {
      if (el.value) el.setAttribute("value", el.value); else el.removeAttribute("value");
      return [el, el.value];
    });
  });
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted || !savedBoxes.length) return;
    var touched = false;                     // the visitor started changing the car: never write old text over it
    var mark = function (ev) { if (ev.target && ev.target.closest && ev.target.closest(".vsearch")) touched = true; };
    ["input", "pointerdown", "focusin", "keydown"].forEach(function (t) { document.addEventListener(t, mark, true); });
    var put = function () {
      if (touched) return;
      savedBoxes.forEach(function (s) { if (s[1] && !s[0].value && !s[0].disabled) s[0].value = s[1]; });
    };
    put(); setTimeout(put, 0); setTimeout(put, 250); setTimeout(put, 1000);
    setTimeout(function () { ["input", "pointerdown", "focusin", "keydown"].forEach(function (t) { document.removeEventListener(t, mark, true); }); }, 1100);
  });
})();
